// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tmh7J{display:flex;align-items:center;gap:4px}.U2DGc{max-width:366px;transition:color .2s ease}.U2DGc.ZoqRn{max-width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptionWrapper": `Tmh7J`,
	"description": `U2DGc`,
	"fullWidth": `ZoqRn`
};
export default ___CSS_LOADER_EXPORT___;
